import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { LocalStorageService } from '../services/common/localstorage-service';
export const RvsfIdInterceptor: HttpInterceptorFn = (req, next) => {
  const localstorageService = inject(LocalStorageService);
  const rvsfDetails: any = localstorageService.get('rvsfDetails');
  const rvsfId = rvsfDetails?.rvsf_id;

  const utcoffset = localstorageService.get('utc_offset');
  // const timeZone = "Asia/Kolkata"
  if (utcoffset) {
    req = req.clone({
      setHeaders: {
        utc_offset: String(utcoffset),
      },
    });
  }
  return next(req);
};
